function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Responsive } from 'react-grid-layout';
// eslint-plugin-import does not support package.json exports field, so we need to disable the rule
// eslint-disable-next-line import/no-unresolved
import { WidthProvider } from 'react-grid-layout/legacy';
import DashboardItem from './dashboardItem';
import DashboardFilterModal from './dashboardFilterModal';
import entityComposition from '../../common/classes/entityComposition';
import { viewPermissionSelector } from '../../common/classes/permissions';
import routeHelper from '../../common/classes/routeHelper';
import Loader from '../../common/loader';
import SinglePicker from '../../common/controls/singlePicker';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
const GridLayout = WidthProvider(Responsive);
const h = 2;
const w = 4;
const generateLayout = currentCharts => {
  let chartsInRow = 0;
  let x = 0;
  let y = 0;
  return currentCharts.map(displayName => {
    const row = {
      x,
      y,
      w,
      h,
      i: displayName,
      minW: 2,
      minH: 2
    };
    chartsInRow += 1;
    x += w;
    if (chartsInRow === 3) {
      y += h;
      x = 0;
      chartsInRow = 0;
    }
    return row;
  });
};
const getFromLS = key => {
  const ls = JSON.parse(global.localStorage.getItem('dashboard')) || {};
  return ls[key];
};
const saveToLS = (key, value) => {
  const values = _objectSpread(_objectSpread({}, JSON.parse(global.localStorage.getItem('dashboard')) || {}), {}, {
    [key]: value
  });
  global.localStorage.setItem('dashboard', JSON.stringify(values));
};

/**
 * When items are added or removed the layout is reset, leading to weird display. Ensure all
 * items have the proper settings
 */
const verifyLayouts = (currentCharts, layouts) => {
  Object.keys(layouts).forEach(layout => {
    layouts[layout].forEach(entry => {
      if (currentCharts.indexOf(entry.i) !== -1) {
        /* eslint-disable no-param-reassign */
        if (entry.w < w) {
          entry.w = w;
        }
        if (entry.h < h) {
          entry.h = h;
        }
        if (!entry.minH || entry.minH === 0) {
          entry.minH = 2;
        }
        if (!entry.minW || entry.minW === 0) {
          entry.minW = 2;
        }
        /* eslint-enable no-param-reassign */
      }
    });
  });
};

/**
 *  jrw - I tried to convert this to a functional component, but ran into various issues, some of
 *    which are documented as issues in the repo: https://github.com/react-grid-layout/react-grid-layout/issues.
 *    Perhaps retry once the web has been updated to React 18+.
 */
class Dashboard extends Component {
  constructor(props) {
    super(props);
    const {
      dashboard: {
        jobs,
        start,
        stop
      }
    } = props;
    const currentCharts = getFromLS('currentCharts') || [];
    const startDate = getFromLS('start') || start || moment().subtract(1, 'week').toISOString();
    const stopDate = getFromLS('stop') || stop || moment().toISOString();
    const originalLayouts = getFromLS('layouts') || {};
    this.state = {
      currentCharts,
      jobs,
      layouts: JSON.parse(JSON.stringify(originalLayouts)),
      selectedChartToAdd: null,
      showFilterModal: false,
      start: startDate,
      stop: stopDate
    };
    this.handleAddChart = this.handleAddChart.bind(this);
    this.handleChartSelection = this.handleChartSelection.bind(this);
    this.handleFilterClose = this.handleFilterClose.bind(this);
    this.handleFilterShow = this.handleFilterShow.bind(this);
    this.handleFilterUpdate = this.handleFilterUpdate.bind(this);
    this.handleLayoutChange = this.handleLayoutChange.bind(this);
    this.handleRemoveChart = this.handleRemoveChart.bind(this);
  }

  /**
   * Set state.currentCharts based on props.dashboard.charts when server data first appears.
   */
  static getDerivedStateFromProps(props, state) {
    const {
      dashboard: {
        charts
      }
    } = props;
    if (!state.currentCharts.length) {
      return {
        currentCharts: Object.keys(charts)
      };
    }
    return null;
  }
  componentDidMount() {
    const {
      canView,
      dashboardActions: {
        serverIndex
      },
      location
    } = this.props;
    const {
      currentCharts,
      jobs,
      start,
      stop
    } = this.state;

    // Redirect and post authorization error message if permissions insufficient
    routeHelper.handleViewRedirect(canView, location);
    serverIndex({
      filters: {
        currentCharts,
        jobs,
        start,
        stop
      }
    });
  }
  handleAddChart() {
    const {
      currentCharts,
      selectedChartToAdd
    } = this.state;
    if (selectedChartToAdd) {
      currentCharts.push(selectedChartToAdd);
      this.setState({
        currentCharts,
        selectedChartToAdd: null
      });
      saveToLS('currentCharts', currentCharts);
      const {
        dashboard: {
          jobs,
          start,
          stop
        },
        dashboardActions: {
          serverIndex
        }
      } = this.props;
      serverIndex({
        filters: {
          currentCharts,
          jobs,
          start,
          stop
        }
      });
    }
  }
  handleChartSelection(name) {
    this.setState({
      selectedChartToAdd: name
    });
  }
  handleFilterClose() {
    this.setState({
      showFilterModal: false
    });
  }
  handleFilterShow() {
    this.setState({
      showFilterModal: true
    });
  }
  handleFilterUpdate(updates) {
    const {
      jobs,
      start,
      stop
    } = updates;
    const {
      dashboardActions: {
        serverIndex
      }
    } = this.props;
    const {
      currentCharts
    } = this.state;
    saveToLS('stop', stop);
    saveToLS('start', start);
    serverIndex({
      filters: {
        currentCharts,
        jobs,
        start,
        stop
      }
    });
    this.setState({
      jobs,
      start,
      stop,
      showFilterModal: false
    });
  }
  handleLayoutChange(layout, layouts) {
    saveToLS('layouts', layouts);
    this.setState({
      layouts
    });
  }
  handleRemoveChart(name) {
    const {
      currentCharts
    } = this.state;
    const indexToRemove = currentCharts.indexOf(name);
    if (indexToRemove !== -1) {
      currentCharts.splice(indexToRemove, 1);
      this.setState({
        currentCharts
      });
      saveToLS('currentCharts', currentCharts);
    }
  }
  render() {
    const {
      dashboard: {
        availableCharts,
        charts,
        loaded
      }
    } = this.props;
    const {
      currentCharts,
      jobs,
      layouts,
      selectedChartToAdd,
      showFilterModal,
      start,
      stop
    } = this.state;
    let displayLayouts = layouts;
    if (!Object.keys(layouts).length) {
      displayLayouts = {
        lg: generateLayout(currentCharts)
      };
    } else {
      verifyLayouts(currentCharts, layouts);
    }
    const selectCharts = [];
    availableCharts.forEach(chartName => {
      if (currentCharts.indexOf(chartName) === -1) {
        selectCharts.push({
          id: chartName,
          name: chartName
        });
      }
    });
    const startDate = moment.utc(start).format('MM/DD/YYYY');
    const stopDate = moment.utc(stop).format('MM/DD/YYYY');
    const chartRows = currentCharts.map(displayName => /*#__PURE__*/React.createElement("div", {
      key: displayName
    }, /*#__PURE__*/React.createElement(DashboardItem, {
      key: displayName,
      config: charts[displayName],
      title: displayName,
      onRemove: this.handleRemoveChart
    })));

    // by using state.jobs, the UI won't automatically show the user's job restrictions, but that
    // should be okay UX. If we want to display that restricted list on initial load, we'd need
    // to move jobSelectDashboard loading from dashboardFilterModal.jsx to here
    let displayJobs = 'All';
    if (jobs && jobs.length) {
      displayJobs = jobs.map(j => j.jobNumber).join(', ');
      if (displayJobs.length > 25) {
        displayJobs = `${displayJobs.substring(0, 25)}...`;
      }
    }
    return /*#__PURE__*/React.createElement(Loader, {
      loaded: loaded
    }, /*#__PURE__*/React.createElement(Container, {
      fluid: true
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      md: 3,
      style: {
        paddingLeft: '25px'
      }
    }, /*#__PURE__*/React.createElement(SinglePicker, {
      onChange: this.handleChartSelection,
      options: selectCharts,
      placeholder: "Available charts...",
      returnValueKey: "name",
      value: selectedChartToAdd
    })), /*#__PURE__*/React.createElement(Col, {
      md: 1
    }, /*#__PURE__*/React.createElement(Button, {
      block: true,
      onClick: this.handleAddChart,
      className: "tqc-control",
      "data-testid": "t-d-addButton"
    }, "Add")), /*#__PURE__*/React.createElement(Col, {
      md: 7,
      style: {
        paddingBottom: '15px',
        textAlign: 'right'
      }
    }, /*#__PURE__*/React.createElement(Row, {
      className: "justify-content-end"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        fontWeight: 'bold',
        textAlign: 'left'
      }
    }, "Dates:", /*#__PURE__*/React.createElement("br", null), "Jobs:"), /*#__PURE__*/React.createElement("div", {
      style: {
        margin: '0 10px 0 10px',
        textAlign: 'left'
      }
    }, startDate, " - ", stopDate, /*#__PURE__*/React.createElement("br", null), displayJobs))), /*#__PURE__*/React.createElement(Col, {
      md: 1,
      style: {
        paddingRight: '25px'
      }
    }, /*#__PURE__*/React.createElement(Button, {
      block: true,
      onClick: this.handleFilterShow,
      className: "tqc-control",
      "data-testid": "t-d-showFilters"
    }, "Filters"))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      md: 12
    }, /*#__PURE__*/React.createElement(GridLayout, {
      className: "layout",
      layouts: displayLayouts,
      onLayoutChange: this.handleLayoutChange,
      "data-testid": "t-d-gridLayout"
    }, chartRows))), /*#__PURE__*/React.createElement(DashboardFilterModal, {
      jobs: jobs,
      onHide: this.handleFilterClose,
      onFilter: this.handleFilterUpdate,
      show: showFilterModal,
      start: start,
      stop: stop
    })));
  }
}
Dashboard.propTypes = {
  canView: PropTypes.bool.isRequired,
  dashboard: PropTypes.shape({
    availableCharts: PropTypes.arrayOf(PropTypes.string),
    charts: PropTypes.shape({}).isRequired,
    indexQuery: PropTypes.shape({}),
    loaded: PropTypes.bool,
    jobs: PropTypes.arrayOf(PropTypes.shape({})),
    start: PropTypes.string,
    stop: PropTypes.string
  }).isRequired,
  dashboardActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  location: PropTypes.shape({}).isRequired // from the router
};
export { Dashboard as TestDashboard };
export default entityComposition(Dashboard, ['dashboard'], {
  canView: state => viewPermissionSelector('dashboard')(state)
});